<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <div>
            <b-form  @submit.prevent="fetch(1)">
              <b-row>
                <b-col>
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="SearchIcon" size="16" class="text-muted" />
                    </b-input-group-prepend>
                    <b-form-input v-model="filter.q" placeholder="Recherche par Nom, Prénom, Email, Téléphone...." class="border-left-0" />
                    <div
                      v-if="hasAnyFilter"
                      class="input-group-text reset-pill" title="Réinitialiser les filtres"
                      role="button"
                      tabindex="0"
                      @mousedown.prevent
                      @click="resetFilters"
                      @keyup.enter="resetFilters"
                    >
                      <feather-icon icon="XIcon" size="14" class="text-danger mr-25" />
                      <span class="text-danger font-small-3">Réinitialiser</span>
                    </div>
                  </b-input-group>
                </b-col>
                <b-col>
                  <v-select :reduce="item => item.id" v-model="filter.concession_id" label="libelle" :options="$store.state.initialConfigModule.initialState.concessions" placeholder="Rechercher par concession"></v-select>
                </b-col>
                <b-col>
                  <v-select :reduce="item => item.id" v-model="filter.site_id" label="libelle" :options="$store.state.initialConfigModule.initialState.sites" placeholder="Rechercher par site"></v-select>
                </b-col>
                <b-col>
                  <v-select :reduce="item => item.id" v-model="filter.role_id" label="libelle" :options="$store.state.initialConfigModule.initialState.roles" placeholder="Rechercher par role"></v-select>
                </b-col>
                <b-col md="auto">
                  <b-button type="submit" variant="primary">Recherche</b-button>
                </b-col>
              </b-row>

             
            </b-form>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-card

        no-body
    >

      <div  >
 
        <div  class="m-2 d-flex justify-content-between">
          <div>
            <b-button
                variant="primary"
                class="mr-1"
                :to="{ name: 'creer-utilisateur'}"
            >
              Créer utilisateur
            </b-button>
            <b-button variant="outline-primary" @click="openImportModal">
              <feather-icon icon="UploadIcon" class="mr-50"/>
              Importer Excel
            </b-button>
          </div>
          <div class="align-self-center">{{pagination.total}} Utilisateurs</div>
        </div>

        <b-modal ref="importModal" title="Importer des utilisateurs" size="xl" hide-footer modal-class="import-users-modal" body-class="p-0">
          <div class="import-modal-body">
            <div v-if="importResult" class="p-3">
              <div class="result-hero" :class="importResult.errors.length ? 'is-warning' : 'is-success'">
                <div class="result-hero__icon">
                  <feather-icon :icon="importResult.errors.length ? 'AlertTriangleIcon' : 'CheckCircleIcon'" size="36"/>
                </div>
                <div>
                  <div class="result-hero__title">
                    {{ importResult.imported }} utilisateur(s) importé(s)
                    <span v-if="importResult.errors.length"> · {{ importResult.errors.length }} erreur(s)</span>
                  </div>
                  <div class="result-hero__sub">{{ importResult.errors.length ? 'Corrigez les lignes ci-dessous puis relancez si besoin.' : 'Tous les utilisateurs ont été créés avec succès.' }}</div>
                </div>
              </div>
              <b-table v-if="importResult.errors.length" :items="importResult.errors" :fields="errorFields" small responsive striped class="mt-2 mb-0"/>
              <div class="text-right mt-3">
                <b-button variant="primary" @click="closeImportModal">Fermer</b-button>
              </div>
            </div>

            <div v-else-if="!importMode" class="mode-picker">
              <h4 class="mode-picker__title">Comment souhaitez-vous importer ?</h4>
              <p class="mode-picker__sub">Choisissez la méthode qui vous convient le mieux.</p>
              <b-row class="mode-picker__cards">
                <b-col md="6" class="mb-2 mb-md-0">
                  <div class="mode-card" @click="importMode = 'file'">
                    <div class="mode-card__icon mode-card__icon--blue">
                      <feather-icon icon="UploadCloudIcon" size="32"/>
                    </div>
                    <h5 class="mode-card__title">Importer depuis PC</h5>
                    <p class="mode-card__desc">Téléversez un fichier Excel ou CSV déjà préparé.</p>
                    <span class="mode-card__cta">Choisir un fichier <feather-icon icon="ArrowRightIcon" size="14"/></span>
                  </div>
                </b-col>
                <b-col md="6">
                  <div class="mode-card" @click="openRemplirMode">
                    <div class="mode-card__icon mode-card__icon--purple">
                      <feather-icon icon="EditIcon" size="32"/>
                    </div>
                    <h5 class="mode-card__title">Remplir le formulaire</h5>
                    <p class="mode-card__desc">Saisissez les utilisateurs directement avec des listes déroulantes.</p>
                    <span class="mode-card__cta">Commencer <feather-icon icon="ArrowRightIcon" size="14"/></span>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div v-else-if="importMode === 'file'" class="p-3">
              <div class="step-header">
                <b-button variant="flat-secondary" size="sm" class="step-header__back" @click="importMode = null">
                  <feather-icon icon="ArrowLeftIcon"/>
                </b-button>
                <div>
                  <h5 class="mb-0">Importer depuis PC</h5>
                  <small class="text-muted">Fichier .xlsx, .xls ou .csv</small>
                </div>
              </div>

              <div class="template-banner">
                <div class="template-banner__icon">
                  <feather-icon icon="FileTextIcon" size="24"/>
                </div>
                <div class="flex-grow-1">
                  <div class="font-weight-bolder">Modèle CSV prêt à l'emploi</div>
                  <small class="text-muted">Colonnes : nom, prenom, email, telephone, password, role, concession, site</small>
                </div>
                <b-button :disabled="downloadingTemplate" @click="downloadTemplate" variant="outline-primary" size="sm">
                  <b-spinner v-if="downloadingTemplate" small class="mr-50"/>
                  <feather-icon v-else icon="DownloadIcon" class="mr-50"/>
                  Télécharger
                </b-button>
              </div>

              <label class="dropzone" :class="{ 'is-active': importFile }">
                <input type="file" accept=".xlsx,.xls,.csv" @change="onFileSelected" hidden>
                <feather-icon :icon="importFile ? 'FileIcon' : 'UploadCloudIcon'" size="40" class="dropzone__icon"/>
                <div class="dropzone__title" v-if="!importFile">Cliquez pour choisir un fichier</div>
                <div class="dropzone__title" v-else>{{ importFile.name }}</div>
                <small class="text-muted" v-if="!importFile">Ou glissez-déposez ici</small>
                <small class="text-muted" v-else>{{ formatBytes(importFile.size) }} · Cliquez pour changer</small>
              </label>

              <div class="text-right mt-3">
                <b-button variant="outline-secondary" class="mr-1" @click="importMode = null" :disabled="importing">Annuler</b-button>
                <b-button variant="primary" :disabled="!importFile || importing" @click="submitImport">
                  <b-spinner v-if="importing" small class="mr-50"/>
                  Importer
                </b-button>
              </div>
            </div>

            <div v-else-if="importMode === 'form'" class="p-3">
              <div class="step-header">
                <b-button variant="flat-secondary" size="sm" class="step-header__back" @click="importMode = null">
                  <feather-icon icon="ArrowLeftIcon"/>
                </b-button>
                <div class="flex-grow-1">
                  <h5 class="mb-0">Remplir le formulaire</h5>
                  <small class="text-muted">{{ importRows.length }} utilisateur{{ importRows.length > 1 ? 's' : '' }} à créer</small>
                </div>
                <b-button size="sm" variant="primary" @click="addRow">
                  <feather-icon icon="PlusIcon" class="mr-50"/>Ajouter
                </b-button>
              </div>

              <div class="user-rows">
                <div v-for="(row, idx) in importRows" :key="idx" class="user-row-card">
                  <div class="user-row-card__head">
                    <span class="user-row-card__badge">#{{ idx + 1 }}</span>
                    <span class="user-row-card__title">
                      {{ (row.prenom || row.nom) ? ((row.prenom || '') + ' ' + (row.nom || '')).trim() : 'Nouvel utilisateur' }}
                    </span>
                    <b-button size="sm" variant="flat-danger" :disabled="importRows.length === 1" @click="removeRow(idx)" class="ml-auto">
                      <feather-icon icon="Trash2Icon"/>
                    </b-button>
                  </div>
                  <b-row class="user-row-card__body">
                    <b-col md="6" lg="3">
                      <label class="field-label">Nom *</label>
                      <b-form-input v-model="row.nom" placeholder="Doe"/>
                    </b-col>
                    <b-col md="6" lg="3">
                      <label class="field-label">Prénom *</label>
                      <b-form-input v-model="row.prenom" placeholder="John"/>
                    </b-col>
                    <b-col md="6" lg="3">
                      <label class="field-label">Email *</label>
                      <b-form-input v-model="row.email" type="email" placeholder="john.doe@exemple.com"/>
                    </b-col>
                    <b-col md="6" lg="3">
                      <label class="field-label">Téléphone *</label>
                      <b-form-input v-model="row.telephone" placeholder="0612345678"/>
                    </b-col>
                    <b-col md="6" lg="3">
                      <label class="field-label">Mot de passe *</label>
                      <b-form-input v-model="row.password" type="text" placeholder="Minimum 6 caractères"/>
                    </b-col>
                    <b-col md="6" lg="3">
                      <label class="field-label">Rôle *</label>
                      <v-select
                        v-model="row.role"
                        :options="rolesList"
                        label="libelle"
                        :clearable="false"
                        :append-to-body="true"
                        :calculate-position="positionDropdown"
                        placeholder="Sélectionner"
                      />
                    </b-col>
                    <b-col md="6" lg="3">
                      <label class="field-label">Concession *</label>
                      <v-select
                        :value="row.concession"
                        @input="onConcessionChange(row, $event)"
                        :options="concessionsList"
                        label="libelle"
                        :clearable="false"
                        :append-to-body="true"
                        :calculate-position="positionDropdown"
                        placeholder="Sélectionner"
                      />
                    </b-col>
                    <b-col md="6" lg="3">
                      <label class="field-label">Site *</label>
                      <v-select
                        v-model="row.site"
                        :options="sitesFor(row.concession)"
                        :disabled="!row.concession"
                        label="libelle"
                        :clearable="false"
                        :append-to-body="true"
                        :calculate-position="positionDropdown"
                        :placeholder="row.concession ? 'Sélectionner' : `Choisissez d'abord la concession`"
                      />
                    </b-col>
                  </b-row>
                </div>
              </div>

              <b-button block variant="outline-primary" class="mt-2" @click="addRow">
                <feather-icon icon="PlusIcon" class="mr-50"/>Ajouter une ligne
              </b-button>

              <div class="text-right mt-3">
                <b-button variant="outline-secondary" class="mr-1" @click="importMode = null" :disabled="importing">Annuler</b-button>
                <b-button variant="primary" :disabled="importing" @click="submitRows">
                  <b-spinner v-if="importing" small class="mr-50"/>
                  Importer {{ importRows.length }} utilisateur{{ importRows.length > 1 ? 's' : '' }}
                </b-button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
      <b-table v-if="items"
               :fields="fields"
               :items="items"

               responsive
               class="mb-0"

      >
        <template #cell(actions)="data">
          <div class="d-flex flex-nowrap" style="gap: 0.5rem;">
            <b-button
              :to="{ name: 'editer-utilisateur', params: { id: data.item.id } }"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              size="sm"
              variant="outline-primary"
            >
              <feather-icon icon="Edit2Icon" />
              Editer
            </b-button>
            <b-button
              v-if="$can('consulter-journal-actions', 'parametres')"
              :to="{ name: 'journal-utilisateur', params: { id: data.item.id } }"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              size="sm"
              variant="outline-info"
            >
              <feather-icon icon="ListIcon" />
              Journal
            </b-button>
          </div>
        </template>
      </b-table>



    </b-card>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
              v-model="pagination.current_page"
              :total-rows="pagination.total"
              :per-page="pagination.per_page"
              first-number
              last-number
              @change="fetch"
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div> 
  </div>

</template>

<script>

import {
  BTable, BButton, BFormGroup, BAvatar, BBadge, BCardBody, BCard, BModal, BSpinner,
  BFormInput, BRow, BCol, BForm, BInputGroup, BInputGroupPrepend, BPagination
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import axios from "@/libs/axios";
import filterPersistence from '@/mixins/filterPersistence'


export default {
  name: "UtilisateursList",
  mixins: [filterPersistence],
  components: {
    BCard,
    BTable,
    BButton,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    BModal,
    BSpinner,
    BFormInput,
    BRow,
    BCol,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BPagination,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      filterKey: 'utilisateurs-list',
      fields: ['id',  'nom','prenom','email',{key : 'role.libelle', label : 'Role'}, {key : 'concession.libelle', label : 'Concession'}, {key : 'actions'  }],      /* eslint-disable global-require */
      items: [],
      pagination : {},
      filter: {
        q: ''
      },
      importMode: null,
      importFile: null,
      importing: false,
      downloadingTemplate: false,
      importResult: null,
      importRows: [],
      rolesList: [],
      concessionsList: [],
      allSites: [],
      errorFields: [
        { key: 'row', label: 'Ligne' },
        { key: 'email', label: 'Email' },
        { key: 'message', label: 'Erreur' },
      ],
    }
  },
  computed: {
    hasAnyFilter() {
      const f = this.filter || {};
      return Object.keys(f).some(k => {
        const v = f[k];
        return v !== null && v !== '' && !(Array.isArray(v) && v.length === 0);
      });
    },
  },

  created() {
    this.fetch(this.restoredPage || 1);
  },
  methods: {
    resetFilters() {
      this.resetFilter();
      this.fetch(1);
    },
    fetch(page) {
      let _this = this;
      _this.is_loading = true;
      this.$store.dispatch('userModule/fetchUtilisateurs', {
        page: page,
        ..._this.filter
      }).then(function (response) {
        _this.items = response.data;
        _this.pagination = response.meta;
        _this.is_loading  = false;
      })
    },
    openImportModal() {
      this.importMode = null;
      this.importFile = null;
      this.importResult = null;
      this.importRows = [];
      this.loadOptions();
      this.$refs.importModal.show();
    },
    loadOptions() {
      const initial = (this.$store.state.initialConfigModule || {}).initialState || {};
      this.rolesList = Array.isArray(initial.roles) ? initial.roles.slice() : [];
      this.concessionsList = Array.isArray(initial.concessions) ? initial.concessions.slice() : [];
      this.allSites = Array.isArray(initial.sites) ? initial.sites.slice() : [];

      if (!this.rolesList.length || !this.concessionsList.length || !this.allSites.length) {
        const _this = this;
        this.$store.dispatch('initialConfigModule/fetchInitialConfig').then(function () {
          const fresh = (_this.$store.state.initialConfigModule || {}).initialState || {};
          _this.rolesList = Array.isArray(fresh.roles) ? fresh.roles.slice() : [];
          _this.concessionsList = Array.isArray(fresh.concessions) ? fresh.concessions.slice() : [];
          _this.allSites = Array.isArray(fresh.sites) ? fresh.sites.slice() : [];
        });
      }
    },
    positionDropdown(dropdownList, component, { width, top, left }) {
      dropdownList.style.position = 'absolute';
      dropdownList.style.top = top;
      dropdownList.style.left = left;
      dropdownList.style.width = width;
      dropdownList.style.zIndex = 2000;
    },
    closeImportModal() {
      this.$refs.importModal.hide();
      this.importMode = null;
      this.importFile = null;
      this.importResult = null;
      this.importRows = [];
    },
    openRemplirMode() {
      this.importMode = 'form';
      if (!this.importRows.length) this.addRow();
    },
    blankRow() {
      return { nom: '', prenom: '', email: '', telephone: '', password: '', role: null, concession: null, site: null };
    },
    addRow() {
      this.importRows.push(this.blankRow());
    },
    removeRow(idx) {
      this.importRows.splice(idx, 1);
    },
    sitesFor(concession) {
      if (!concession) return [];
      return this.allSites.filter(s => s.concession && s.concession.id === concession.id);
    },
    onConcessionChange(row, value) {
      row.concession = value;
      row.site = null;
    },
    onFileSelected(event) {
      const f = event.target.files && event.target.files[0];
      if (f) this.importFile = f;
      event.target.value = '';
    },
    formatBytes(bytes) {
      if (!bytes && bytes !== 0) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },
    downloadTemplate() {
      const _this = this;
      _this.downloadingTemplate = true;
      axios.get('/api/utilisateurs/import-template', { responseType: 'blob' })
        .then(function (response) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'modele-import-utilisateurs.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(function () {
          _this.downloadingTemplate = false;
        });
    },
    submitImport() {
      const _this = this;
      const formData = new FormData();
      formData.append('file', this.importFile);
      _this.importing = true;
      axios.post('/api/utilisateurs/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(function (response) {
        _this.importing = false;
        _this.importResult = response.data;
        _this.fetch(_this.pagination.current_page || 1);
      }).catch(function () {
        _this.importing = false;
      });
    },
    submitRows() {
      const _this = this;
      _this.importing = true;
      axios.post('/api/utilisateurs/import-rows', { rows: _this.importRows }).then(function (response) {
        _this.importing = false;
        _this.importResult = response.data;
        _this.fetch(_this.pagination.current_page || 1);
      }).catch(function () {
        _this.importing = false;
      });
    },
  },
}
</script>

<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

/* ===== Import users modal ===== */
.import-users-modal {
  .modal-content {
    border: 0;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(34, 41, 47, .18);
  }
  .modal-header {
    border-bottom: 1px solid #ebe9f1;
    padding: 1rem 1.5rem;
  }
}

.import-modal-body {
  background: #fafbfc;
  min-height: 200px;
}

/* Mode picker */
.mode-picker {
  padding: 2rem 1.5rem;
  text-align: center;
  &__title { font-weight: 600; margin-bottom: .25rem; }
  &__sub   { color: #6e6b7b; margin-bottom: 1.5rem; }
}
.mode-card {
  position: relative;
  background: #fff;
  border: 1px solid #ebe9f1;
  border-radius: 12px;
  padding: 1.75rem 1.25rem 1.25rem;
  cursor: pointer;
  text-align: center;
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
  height: 100%;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(115, 103, 240, .15);
    border-color: #7367f0;
  }
  &__icon {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    margin: 0 auto 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    &--blue   { background: linear-gradient(135deg, #00cfe8, #1e9ff2); }
    &--purple { background: linear-gradient(135deg, #7367f0, #9c8cfc); }
  }
  &__title { font-weight: 600; margin-bottom: .35rem; }
  &__desc  { color: #6e6b7b; font-size: .85rem; margin-bottom: 1rem; }
  &__cta   {
    color: #7367f0;
    font-size: .85rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: .25rem;
  }
}

/* Step header (back button + title) */
.step-header {
  display: flex;
  align-items: center;
  gap: .75rem;
  margin-bottom: 1.25rem;
  &__back { padding: .35rem; }
}

/* Template download banner */
.template-banner {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: #f0eefe;
  border: 1px dashed #c8c1f5;
  border-radius: 10px;
  padding: .85rem 1rem;
  margin-bottom: 1rem;
  &__icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #7367f0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
}

/* File dropzone */
.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: .35rem;
  padding: 2.25rem 1rem;
  border: 2px dashed #d8d6de;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: border-color .15s, background .15s;
  text-align: center;
  margin-bottom: 0;

  &:hover { border-color: #7367f0; background: #faf9ff; }
  &.is-active {
    border-color: #28c76f;
    background: #effcf4;
    .dropzone__icon { color: #28c76f; }
  }
  &__icon  { color: #b9b9c3; }
  &__title { font-weight: 600; color: #5e5873; }
}

/* User row cards (Remplir form) */
.user-rows { display: flex; flex-direction: column; gap: .75rem; }

.user-row-card {
  background: #fff;
  border: 1px solid #ebe9f1;
  border-radius: 12px;
  overflow: hidden;
  transition: box-shadow .15s ease, border-color .15s ease;

  &:hover { box-shadow: 0 6px 18px rgba(34,41,47,.06); border-color: #d4d0f5; }

  &__head {
    display: flex;
    align-items: center;
    gap: .65rem;
    padding: .65rem 1rem;
    background: linear-gradient(90deg, #f8f7ff, #fff);
    border-bottom: 1px solid #ebe9f1;
  }
  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 26px;
    padding: 0 .5rem;
    border-radius: 999px;
    background: #7367f0;
    color: #fff;
    font-size: .75rem;
    font-weight: 700;
  }
  &__title { font-weight: 600; color: #5e5873; }
  &__body  { padding: 1rem; row-gap: .75rem; }
}

.field-label {
  display: block;
  font-size: .75rem;
  font-weight: 600;
  color: #6e6b7b;
  margin-bottom: .25rem;
  text-transform: uppercase;
  letter-spacing: .03em;
}

/* Result hero banner */
.result-hero {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.25rem;
  border-radius: 12px;
  color: #fff;

  &.is-success { background: linear-gradient(135deg, #28c76f, #48da89); }
  &.is-warning { background: linear-gradient(135deg, #ff9f43, #ffb976); color: #fff; }

  &__icon {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    background: rgba(255,255,255,.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  &__title { font-size: 1.1rem; font-weight: 600; }
  &__sub   { opacity: .9; font-size: .85rem; }
}

/* Tighten v-select inside modal */
.import-users-modal .v-select .vs__dropdown-toggle { min-height: 38px; }
</style>
